const getSource = shape => shape.get('source', '').split('/').pop();

export default getSource;
